export const systemRoutes = [
  {
    path: '/system/market',
    component: () => import('@/views/modules/system/market/market'),
    meta: { name: '店铺授权', keepAlive: true, permission: 'market:view' ,modal:'系统'}
  },
  {
    path: '/system/exchange-rate',
    component: () => import('@/views/modules/system/exchange-rate/exchange-rate'),
    meta: { name: '汇率管理', keepAlive: true, permission: 'exchangeRate:view' ,modal:'系统'}
  },
];
